import { render, staticRenderFns } from "./Bigbtn.vue?vue&type=template&id=1ff7cf80&scoped=true"
import script from "./Bigbtn.vue?vue&type=script&lang=js"
export * from "./Bigbtn.vue?vue&type=script&lang=js"
import style0 from "./Bigbtn.vue?vue&type=style&index=0&id=1ff7cf80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff7cf80",
  null
  
)

export default component.exports